import { cn } from '../../lib/utils';
import React from 'react'

export default function StatusFilters({
  items = [], // Array of { id, label, icon, activeStyle, inactiveStyle, inactiveIconClass }
  activeStatus = '',
  onStatusChange,
  children, // For Toolbar section
  isDark = false,
}) {
  return (
    <div
      className={cn(
        "rounded-[24px] p-[16px] sm:p-[24px] flex flex-col gap-[12px] sm:gap-[16px] border-solid border-[1px] transition-colors duration-200",
        isDark ? 'bg-[#161515] border-[#292929]' : 'bg-white border-[#d9d9d9]'
      )}
    >
      <div className={cn("flex items-center gap-[10px]")}>
        <span
          className={cn(
            "text-[14px] sm:text-[16px] font-semibold transition-colors duration-200",
            isDark ? 'text-white' : 'text-[#072837]'
          )}
        >
          Filters:
        </span>
      </div>
      <div className={cn("flex flex-wrap items-center gap-[12px] sm:gap-[16px]")}>
        {items.map((item, idx) => {
          const isActive = Array.isArray(activeStatus) ? activeStatus.includes(item.id) : activeStatus === item.id;
          const buttonStyle = isActive ? item.activeStyle : item.inactiveStyle;
          const iconColorClass = isActive ? (item.activeIconClass || 'bg-white') : item.inactiveIconClass;

          return (
            <button
              key={idx}
              type="button"
              className={cn(
                "group",
                buttonStyle,
                "px-[16px] py-[7px] rounded-[8px] inline-flex items-center gap-[4px] text-[13px] whitespace-nowrap transition-colors duration-200 border-0"
              )}
              onClick={() => onStatusChange?.(item.id)}
            >
              {item.icon && (
                <div
                  className={cn(
                    "w-[13px] h-[13px]",
                    iconColorClass,
                    !isActive ? 'group-hover:bg-white' : '',
                    "transition-colors duration-200"
                  )}
                  style={{
                    maskImage: `url(${item.icon})`,
                    WebkitMaskImage: `url(${item.icon})`,
                    maskSize: 'contain',
                    WebkitMaskSize: 'contain',
                    maskRepeat: 'no-repeat',
                    WebkitMaskRepeat: 'no-repeat',
                    maskPosition: 'center',
                    WebkitMaskPosition: 'center',
                  }}
                />
              )}
              {item.label}
            </button>
          );
        })}
      </div>
      {children && (
        <>
          <div className={cn(
            "w-full h-px transition-colors duration-200",
            isDark ? 'bg-[#292929]' : 'bg-[#d9d9d9]'
          )} />
          {children}
        </>
      )}
    </div>
  );
}
